import React, { createContext, useContext, useState, useCallback } from 'react';

const LecturaContext = createContext(null);

export function LecturaProvider({ children }) {
  const [resultado, setResultado] = useState(() => {
    // Hidrata desde sessionStorage al montar (por si el usuario refresca)
    try {
      const guardado = sessionStorage.getItem('resultado');
      return guardado ? JSON.parse(guardado) : null;
    } catch {
      return null;
    }
  });

  // Almacena los datos del formulario en memoria (File no serializable)
  // para pasarlos a Procesando.js sin esperar en el formulario
  const [pendingForm, setPendingForm] = useState(null);

  const guardarResultado = useCallback((data) => {
    setResultado(data);
    sessionStorage.setItem('resultado', JSON.stringify(data));
  }, []);

  const limpiarResultado = useCallback(() => {
    setResultado(null);
    sessionStorage.removeItem('resultado');
  }, []);

  const desbloquear = useCallback(() => {
    setResultado(prev => {
      if (!prev) return prev;
      const desbloqueado = { ...prev, esPremium: true };
      sessionStorage.setItem('resultado', JSON.stringify(desbloqueado));
      return desbloqueado;
    });
  }, []);

  const guardarPendingForm = useCallback((datos) => {
    setPendingForm(datos);
  }, []);

  const limpiarPendingForm = useCallback(() => {
    setPendingForm(null);
  }, []);

  return (
    <LecturaContext.Provider value={{
      resultado, guardarResultado, limpiarResultado, desbloquear,
      pendingForm, guardarPendingForm, limpiarPendingForm
    }}>
      {children}
    </LecturaContext.Provider>
  );
}

export function useLectura() {
  const ctx = useContext(LecturaContext);
  if (!ctx) throw new Error('useLectura debe usarse dentro de <LecturaProvider>');
  return ctx;
}
